export default __webpack_public_path__ + "static/media/R5No6.745b3323.mp3";